import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ExpandLessIcon(props: IconProps) {
    return <Icon {...props} iconKey={"expand_less"}/>
}
